export const RR_TERMS = {
	priceUsd: 199,
	trialDays: 7,
	applicationsPerWeek: 5,
	freeApplications: 5,
	vetoWindowHours: 24,
	auditTurnaroundHours: 48,
	refundDays: 7,
	memberCap: 20,
	intakeTtlDays: 14,
} as const

export const priceLabel = `$${RR_TERMS.priceUsd}`

export const priceWithPeriod = `${priceLabel} a month`

export const trialLengthLabel = `${RR_TERMS.trialDays} days`

export const vetoWindowLabel = `${RR_TERMS.vetoWindowHours} hours`

// Protected text. This is the sentence a chargeback turns on; do not shorten it.
export function authorizationSentence(firstChargeDate: string) {
	return (
		`I authorize Resume Tailor to apply to jobs in my name, using my resume and ` +
		`the answers I gave. Every application is announced to me first, and it goes ` +
		`out unless I stop it within ${RR_TERMS.vetoWindowHours} hours. ` +
		`Today I am charged $0. On ${firstChargeDate} my card is charged ` +
		`${priceLabel}, and ${priceLabel} every month after that until I cancel.`
	)
}

export function firstChargeDate(trialStartedAt: Date): Date {
	const d = new Date(trialStartedAt)
	d.setDate(d.getDate() + RR_TERMS.trialDays)
	return d
}

// Both formatters pin Eastern: these render a veto deadline and a charge date,
// and without a zone they differ between the server and the browser.
export function formatDay(date: Date | string) {
	const d = typeof date === 'string' ? new Date(date) : date
	return d.toLocaleDateString('en-US', {
		month: 'long',
		day: 'numeric',
		timeZone: 'America/New_York',
	})
}

export function formatStamp(date: Date | string) {
	const d = typeof date === 'string' ? new Date(date) : date
	return d.toLocaleString('en-US', {
		month: 'short',
		day: 'numeric',
		hour: 'numeric',
		minute: '2-digit',
		timeZone: 'America/New_York',
		timeZoneName: 'short',
	})
}

export function timeLeftLabel(closesAt: Date | string, now: Date = new Date()) {
	const closes = typeof closesAt === 'string' ? new Date(closesAt) : closesAt
	const ms = closes.getTime() - now.getTime()
	if (ms <= 0) return null
	const hours = Math.floor(ms / (1000 * 60 * 60))
	if (hours >= 1) {
		const mins = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60))
		if (hours >= 6) return `${hours} hours`
		return mins > 0 ? `${hours}h ${mins}m` : `${hours} hours`
	}
	const mins = Math.max(1, Math.floor(ms / (1000 * 60)))
	return `${mins} minutes`
}
